import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext();

// Selectable portal accent colors. `id` maps to the [data-accent] value read
// by index.css (gold is the default = no attribute). `swatch` is the display
// color for the picker circle in Settings.
export const ACCENTS = [
  { id: 'gold', name: 'Gold', swatch: '#ffd700' },
  { id: 'forest', name: 'Forest', swatch: '#15803d' },
  { id: 'night', name: 'Night', swatch: '#1d4ed8' },
  { id: 'crimson', name: 'Crimson', swatch: '#be123c' },
];

const VALID_ACCENTS = ACCENTS.map((a) => a.id);

export const ThemeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem('darkMode') === 'true';
  });

  const [accent, setAccentState] = useState(() => {
    const stored = localStorage.getItem('portalAccent');
    return VALID_ACCENTS.includes(stored) ? stored : 'gold';
  });

  useEffect(() => {
    document.documentElement.classList.toggle('dark', darkMode);
  }, [darkMode]); // Dependency array ensures it only runs when darkMode changes

  useEffect(() => {
    // Gold is the default (no attribute); others stamp data-accent on <html>.
    if (accent === 'gold') {
      document.documentElement.removeAttribute('data-accent');
    } else {
      document.documentElement.setAttribute('data-accent', accent);
    }
  }, [accent]);

  const toggleDarkMode = () => {
    setDarkMode((prevMode) => {
      const newMode = !prevMode;
      localStorage.setItem('darkMode', newMode);
      return newMode;
    });
  };

  const setAccent = (id) => {
    if (!VALID_ACCENTS.includes(id)) return;
    localStorage.setItem('portalAccent', id);
    setAccentState(id);
  };

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode, accent, setAccent }}>
      {children}
    </ThemeContext.Provider>
  );
};
